import { render, staticRenderFns } from "./AlertDetail.vue?vue&type=template&id=8b1f61ac"
import script from "./AlertDetail.vue?vue&type=script&lang=js"
export * from "./AlertDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports